/**
 * Marwin.ro — Public Site JavaScript (source)
 * Compiled by Gulp -> public/assets/js/public.min.js
 */

(function ($) {
    'use strict';

    /* ------------------------------------------------------------------
       Navbar: frosted glass on scroll + transparent on homepage hero
       ------------------------------------------------------------------ */
    function handleNavbarScroll() {
        var $nav       = $('.navbar-marwin');
        var isHomepage = $('body').hasClass('homepage');

        function update() {
            var scrolled = $(window).scrollTop() > 20;
            $nav.toggleClass('scrolled', scrolled);
            if (isHomepage) {
                $nav.toggleClass('nav-transparent', !scrolled);
            }
        }

        $(window).on('scroll.navbar', update);
        update();
    }

    /* ------------------------------------------------------------------
       Mobile slide-in drawer (custom, no Bootstrap collapse)
       ------------------------------------------------------------------ */
    function initMobileMenu() {
        var $toggler  = $('#navbarToggler');
        var $drawer   = $('#navbarNav');
        var $backdrop = $('#navBackdrop');
        var $close    = $('#navbarClose');

        if (!$toggler.length) return;

        function openMenu() {
            $drawer.addClass('drawer-open');
            $backdrop.addClass('active').attr('aria-hidden', 'false');
            $toggler.attr('aria-expanded', 'true');
            $('body').addClass('menu-open');
        }

        function closeMenu() {
            $drawer.removeClass('drawer-open');
            $backdrop.removeClass('active').attr('aria-hidden', 'true');
            $toggler.attr('aria-expanded', 'false');
            $('body').removeClass('menu-open');
        }

        $toggler.on('click', function () {
            $drawer.hasClass('drawer-open') ? closeMenu() : openMenu();
        });

        $close.on('click', closeMenu);
        $backdrop.on('click', closeMenu);

        $drawer.find('.nav-link').on('click', closeMenu);

        $(document).on('keydown.drawer', function (e) {
            if (e.key === 'Escape' && $drawer.hasClass('drawer-open')) closeMenu();
        });
    }

    /* ------------------------------------------------------------------
       Smooth scroll for hash links
       ------------------------------------------------------------------ */
    function initSmoothScroll() {
        $(document).on('click', 'a[href^="#"]', function (e) {
            var target = $(this).attr('href');
            if (target.length > 1 && $(target).length) {
                e.preventDefault();
                var offset = $('.navbar-marwin').outerHeight() + 8;
                $('html, body').animate({ scrollTop: $(target).offset().top - offset }, 480);
            }
        });
    }

    /* ------------------------------------------------------------------
       Contact form: client-side validation
       ------------------------------------------------------------------ */
    function initContactForm() {
        var $form = $('#contactForm');
        if (!$form.length) return;

        $form.on('submit', function (e) {
            var valid = true;
            $form.find('[required]').each(function () {
                var $f = $(this);
                if (!$f.val().trim()) { $f.addClass('is-invalid'); valid = false; }
                else { $f.removeClass('is-invalid').addClass('is-valid'); }
            });
            if (!valid) { e.preventDefault(); $form.find('.is-invalid').first().focus(); }
        });

        $form.find('[required]').on('input change', function () {
            $(this).removeClass('is-invalid is-valid');
        });
    }

    /* ------------------------------------------------------------------
       Cookie consent banner
       ------------------------------------------------------------------ */
    function initCookieBanner() {
        var KEY    = 'marwin_cookie_consent';
        var $banner = $('#cookieBanner');

        if (!$banner.length || localStorage.getItem(KEY)) return;

        setTimeout(function () { $banner.addClass('visible'); }, 800);

        function dismiss(choice) {
            localStorage.setItem(KEY, choice);
            $banner.removeClass('visible');
            setTimeout(function () { $banner.remove(); }, 450);
        }

        $('#cookieAccept').on('click', function () { dismiss('accepted'); });
        $('#cookieDecline').on('click', function () { dismiss('declined'); });
    }

    /* ------------------------------------------------------------------
       Init
       ------------------------------------------------------------------ */
    $(function () {
        handleNavbarScroll();
        initMobileMenu();
        initSmoothScroll();
        initContactForm();
        initCookieBanner();
    });

}(jQuery));
